import Dexie from 'dexie';

const DEVICE_KEY = 'sar_device_id';

// Initialize Dexie
export const db = new Dexie('SARIA_OfflineStore');
db.version(1).stores({
  outbox: 'client_operation_id, queued_at, status' // status: pending, failed
});

export function getDeviceId() {
  let deviceId = localStorage.getItem(DEVICE_KEY);
  if (!deviceId) {
    deviceId = (crypto && crypto.randomUUID) ? crypto.randomUUID() : `device-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(DEVICE_KEY, deviceId);
  }
  return deviceId;
}

export async function getOutbox() {
  return await db.outbox.orderBy('queued_at').toArray();
}

export async function getPendingCount() {
  return await db.outbox.count();
}

export async function enqueueOperation({ entityType, operationType = 'create', payload }) {
  const operation = {
    client_operation_id: (crypto && crypto.randomUUID) ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`,
    source_device_id: getDeviceId(),
    entity_type: entityType,
    operation_type: operationType,
    payload,
    queued_at: new Date().toISOString(),
    status: 'pending'
  };
  
  await db.outbox.add(operation);
  window.dispatchEvent(new Event('sar-outbox-changed'));
  
  // Attempt to trigger background sync if supported
  if ('serviceWorker' in navigator && 'SyncManager' in window) {
    try {
      const swRegistration = await navigator.serviceWorker.ready;
      await swRegistration.sync.register('sar-sync-outbox');
    } catch (err) {
      console.warn('Background sync registration failed:', err);
    }
  }

  return operation;
}

export async function flushOutbox() {
  const outbox = await getOutbox();
  if (outbox.length === 0) return { success: true, total: 0, synced: 0 };

  const token = localStorage.getItem('auth_token');
  const headers = new Headers({ 'Content-Type': 'application/json' });
  if (token) headers.set('Authorization', `Bearer ${token}`);

  let res;
  try {
    res = await fetch((process.env.REACT_APP_API_URL || '') + '/api/sync/push', {
      method: 'POST',
      headers,
      body: JSON.stringify({ operations: outbox })
    });
  } catch (networkErr) {
    throw new Error('Falha de rede. A API não está alcançável.');
  }

  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) throw new Error(data.error || `HTTP ${res.status}`);

  const completed = new Set((data.results || [])
    .filter(result => result.operation && ['applied', 'failed'].includes(result.operation.status))
    .map(result => result.operation.client_operation_id));
    
  // Delete synced operations
  const idsToDelete = outbox
    .filter(operation => completed.has(operation.client_operation_id))
    .map(operation => operation.client_operation_id);
    
  if (idsToDelete.length > 0) {
    await db.outbox.bulkDelete(idsToDelete);
  }

  const remaining = await getPendingCount();
  window.dispatchEvent(new Event('sar-outbox-changed'));
  
  return { ...data, synced: completed.size, remaining };
}

